module.exports = __webpack_public_path__ + "static/media/oberflex-noyerameriquet266-2560x1440.ba57d178.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-noyerameriquet266-2560x1440.jpg
// module id = 1037
// module chunks = 37